import { createFileRoute } from '@tanstack/react-router';

import Advanced from 'component/view/SiteDetails/Advanced';

import { requireOperation } from './-guards';
import { siteTabOperations } from './-site-tabs';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/advanced')({
  beforeLoad: requireOperation({
    options: ({ params }) => siteTabOperations.advanced(params.siteId),
    siteId: ({ params }) => params.siteId,
  }),
  component: Advanced,
});
